import { render, staticRenderFns } from "./HLQFoot.vue?vue&type=template&id=6043ecd6&scoped=true"
import script from "./HLQFoot.vue?vue&type=script&lang=js"
export * from "./HLQFoot.vue?vue&type=script&lang=js"
import style0 from "./HLQFoot.vue?vue&type=style&index=0&id=6043ecd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043ecd6",
  null
  
)

export default component.exports